<template>
  <div class="backgroundPoliticaAmbiental" id="background4">
    <div class="transbox" id="transbox4">
      <h1 class="pulse">Política Medioambiental </h1>
      <br>
      <v-img 
      src="../assets/politicaAmbiental.png" aspect-ratio="1" 
      height=867
      width=630
      class="image"></v-img>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Autorizaciones',
  props: {
    msg: String
  },
  created(){
    window.addEventListener("scroll", function () {
      if (document.querySelector("#background4").getBoundingClientRect().top < this.window.innerHeight){
        document.querySelector("#transbox4").classList.add("animation")
      } 
    })
  }
}
</script>

<style scoped>
h3 {
  margin: 40px 0 0;
}
li{
  margin: 0 40px 0;
}
a {
  color: #42b983;
}

div.backgroundPoliticaAmbiental {
  padding-left: 5%;
  padding-right: 5%;
  padding-top: 5px;
  padding-bottom: 5px;
  min-width: 800px;
}

div.transbox {
   margin: 30px;
  padding : 5%;
  font-family: Arial, Helvetica, sans-serif;
  text-align: justify;
  background: linear-gradient(300deg, rgb(27, 94, 32, 0.8) 0%, rgba(144,238,144,0.8) 50%, rgb(255, 255, 255, 0.8) 100%);
  box-shadow: 10px 10px 5px 0px rgba(0,0,0,0.75);
  border-radius: 15px;
  min-width: 750px;
}

div {
  font-size: 30px;
}
.image{
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 50%;
}
.animation{
  animation-name: opacity1;
  animation-duration: 1500ms;
  transform-origin:70% 70%;
  animation-iteration-count: initial;
  animation-timing-function: linear;
}

@keyframes opacity1 {
  0% {
        display: none;
        opacity: 0;
    }

    1% {
        display: block;
        opacity: 0;
    }

    100% {
        display: block;
        opacity: 0.8;
    }
}
.pulse:hover {
    animation-name: pulse_animation1;
    animation-duration: 5000ms;
    transform-origin:0% 70%;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
}

@keyframes pulse_animation1 {
  0% { transform: scale(1); }
  50% { transform: scale(1.2); }
  100% { transform: scale(1); }
}
</style>